(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  class ImageBannerCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.banner-carousel__track');
      this.slides = Array.from(this.querySelectorAll('.banner-carousel__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.index = 0;
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot))));
      if (this.dataset.autoplay === 'true' && this.slides.length > 1) {
        this.timer = setInterval(() => this.go(this.index + 1), Number(this.dataset.speed) || 5000);
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    go(nextIndex) {
      if (!this.slides.length) return;
      this.index = (nextIndex + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', index === this.index ? 'true' : 'false'));
    }
  }

  if (!customElements.get('image-banner-carousel')) {
    customElements.define('image-banner-carousel', ImageBannerCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-countdown"] && !Shopify.designMode) return;
  try {
    
  class ProCountdown extends HTMLElement {
    connectedCallback() {
      this.deadline = this.parseDeadline();
      this.days = this.querySelector('[data-days]');
      this.hours = this.querySelector('[data-hours]');
      this.minutes = this.querySelector('[data-minutes]');
      this.seconds = this.querySelector('[data-seconds]');
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    parseDeadline() {
      let deadline = this.dataset.deadline || '';
      const timezone = this.dataset.timezone || '';
      if (deadline && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(deadline) && timezone) {
        deadline = `${deadline}${timezone}`;
      }
      return new Date(deadline).getTime();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const distance = Math.max(0, this.deadline - Date.now());
      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);
      this.days.textContent = String(days).padStart(2, '0');
      this.hours.textContent = String(hours).padStart(2, '0');
      this.minutes.textContent = String(minutes).padStart(2, '0');
      this.seconds.textContent = String(seconds).padStart(2, '0');
    }
  }

  if (!customElements.get('pro-countdown')) {
    customElements.define('pro-countdown', ProCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-image-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProBannerCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pro-banner-carousel__track');
      this.slides = Array.from(this.querySelectorAll('.pro-banner-carousel__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.index = 0;
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot))));
      if (this.dataset.autoplay === 'true' && this.slides.length > 1) {
        this.timer = setInterval(() => this.go(this.index + 1), Number(this.dataset.speed) || 5000);
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    go(nextIndex) {
      if (!this.slides.length) return;
      this.index = (nextIndex + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', index === this.index ? 'true' : 'false'));
    }
  }

  if (!customElements.get('pro-banner-carousel')) {
    customElements.define('pro-banner-carousel', ProBannerCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
